export default __webpack_public_path__ + "static/media/p7_main.43dadded.png";